import { Routes } from '@angular/router';
import { ComingSoonComponent } from './coming-soon.component';
import { SignupComponent } from './signup.component';
import { SigninComponent } from './signin.component';
import { HomeComponent } from './home.component';
import { ForgotPasswordComponent } from './forgot-password.component';
import { ResetPasswordComponent } from './reset-password.component';
import { AdminLayoutComponent } from './admin/admin-layout.component';
import { adminGuard } from './guards/admin.guard';
import { CartComponent } from './cart/cart.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { WishlistComponent } from './wishlist/wishlist.component';
import { AboutComponent } from './about.component';
import { FaqComponent } from './faq.component';
import { PrivacyPolicyComponent } from './privacy-policy.component';
import { authGuard } from './guards/auth.guard';
import { QrManagerComponent } from './qr-manager/qr-manager.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'product/:id',
    loadComponent: () => import('./product-details/product-details.component').then(m => m.ProductDetailsComponent)
  },
  {
    path: 'coming-soon',
    component: ComingSoonComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  },
  {
    path: 'cart',
    component: CartComponent
  },
  {
    path: 'profile',
    component: UserProfileComponent,
    canActivate: [authGuard]
  },
  {
    path: 'wishlist',
    component: WishlistComponent,
    canActivate: [authGuard]
  },
  {
    path: 'about-us',
    component: AboutComponent
  },
  {
    path: 'faq',
    component: FaqComponent
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent
  },
  {
    path: 'checkout',
    loadComponent: () => import('./checkout/checkout.component').then(m => m.CheckoutComponent),
    canActivate: [authGuard]
  },
  {
    path: 'order-success/:orderId',
    loadComponent: () => import('./order-success/order-success.component').then(m => m.OrderSuccessComponent),
    canActivate: [authGuard]
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [adminGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { 
        path: 'dashboard', 
        loadComponent: () => import('./admin/dashboard/dashboard-overview.component').then(m => m.DashboardOverviewComponent)
      },
      { 
        path: 'products', 
        loadComponent: () => import('./admin/products/product-management.component').then(m => m.ProductManagementComponent)
      },
      { 
        path: 'orders', 
        loadComponent: () => import('./admin/orders/order-management.component').then(m => m.OrderManagementComponent)
      },
      { 
        path: 'reviews', 
        loadComponent: () => import('./admin/reviews/review-management.component').then(m => m.ReviewManagementComponent)
      },
      { 
        path: 'customers', 
        loadComponent: () => import('./admin/customers/customer-management.component').then(m => m.CustomerManagementComponent)
      },
      {
        path: 'referral-sources',
        loadComponent: () => import('./admin/referral-sources/referral-sources.component').then(m => m.ReferralSourcesComponent)
      }
    ]
  },
  {
    path: 'qr-admin',
    component: QrManagerComponent
  },
  /* {
    path: 'whatsapp-demo',
    loadComponent: () => import('./whatsapp-demo/whatsapp-demo.component').then(m => m.WhatsAppDemoComponent)
  }, */
  // Legacy/External Redirects
  {
    path: 'products/:id/review',
    redirectTo: 'product/:id?tab=reviews'
  },
  {
    path: 'products/:id',
    redirectTo: 'product/:id'
  },
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];
